import request from '@/request/request'
// 获取今日客流
export function getTodayFlow(data) {
    return request({
        url: '/api/analysis/staPassengerAnalysis/getAreaYOYMOMData',
        method: 'post',
        data: data
    })
}

// 获取客流趋势
export function getFlowTrend(data) {
    return request({
        url: '/api/analysis/staPassengerAnalysis/getYOYTrendByTimes',
        method: 'post',
        data: data
    })
}

// 获取今日车流
export function getTodayCar(data) {
    return request({
        url: '/api/analysis/staCarAnalysis/getAreaYOYMOMData',
        method: 'post',
        data: data
    })
}
// // 获取车流按日期查询
// export function getTrendByTimes(data) {
//     return request({
//         url: '/jk/analysis/staCarAnalysis/getTrendByTimes',
//         method: 'post',
//         data: data
//     })
// }

// 获取停车场数据
export function getCarPark(data) {
    return request({
        url: '/api/analysis/staRealParking/getRealTimeData',
        method: 'post',
        data: data
    })
}

// 票务统计-售票相关
export function getTypeDataByTimes(data) {
    return request({
        url: '/api/analysis/staTicketSell/getTypeDataByTimes',
        method: 'post',
        data: data
    })
}
export function getYOYTrendByTimes(data) {
    return request({
        url: '/api/analysis/staTicketSell/getYOYTrendByTimes',
        method: 'post',
        data: data
    })
}

// 票务统计-游客画像相关
export function getSexByTimes(data) {
    return request({
        url: '/api/analysis/staPassengerAnalysis/getSexByTimes',
        method: 'post',
        data: data
    })
}
export function getGroupDataByTimeValue(data) {
    return request({
        url: '/api/analysis/staTicketSell/getGroupDataByTimes',
        method: 'post',
        data: data
    })
}
export function getTypeByTimes(data) {
    return request({
        url: '/api/analysis/staTicketSell/getTypeByTimes',
        method: 'post',
        data: data
    })
}
export function getAgeByTimes(data) {
    return request({
        url: '/api/analysis/staPassengerAnalysis/getAgeByTimes',
        method: 'post',
        data: data
    })
}

export function getSourceProvinceByTimeValue(type,data) {
    return request({
        url: `/api/analysis/${type}/getSourceProvinceByTimeValue`,
        method: 'post',
        data: data
    })
}
export function getSourceCityByTimeValue(type,data) {
    return request({
        url: `/api/analysis/${type}/getSourceCityByTimeValue`,
        method: 'post',
        data: data
    })
}
export function getTrendByTimes(type,data) {
    return request({
        url: `/api/analysis/${type}/getTrendByTimes`,
        method: 'post',
        data: data
    })
}
export function getAgeByTimes2(type,data) {
    return request({
        url: `/api/analysis/${type}/getAgeByTimes`,
        method: 'post',
        data: data
    })
}
export function getSexByTimes2(type,data) {
    return request({
        url: `/api/analysis/${type}/getSexByTimes`,
        method: 'post',
        data: data
    })
}
export function getTravelAgencyDataByTimes(type,data) {
    return request({
        url: `/api/analysis/${type}/getTravelAgencyDataByTimes`,
        method: 'post',
        data: data
    })
}
export function getRealTimeData(type,data) {
    return request({
        url: `/api/analysis/${type}/getRealTimeData`,
        method: 'post',
        data: data
    })
}
export function getSysDictionary(groupCode) {
    return request({
        url: `/api/analysis/sysDictionary/findPage`,
        method: 'post',
        data: {groupCode,"columnName":"id","columnSortType":"desc","page":1,"size":999}
    })
}
// 根据主体类型获取单位
export function  getEntityBaseAllInfo(data) {
    return request({
        url: '/api/data-server/data/entityBaseAllInfo/findPage',
        method: 'post',
        data
    })
}
export function  getProvince(data) {
    return request({
        url: '/api/data-server/data/resArea/getProvince',
        method: 'post',
        data
    })
}
export function  getCity(data) {
    return request({
        url: '/api/data-server/data/resArea/getCity',
        method: 'post',
        data
    })
}
export function  getDistrict(data) {
    return request({
        url: '/api/data-server/data/resArea/getDistrict',
        method: 'post',
        data
    })
}